import _ from 'lodash';
import $ from 'jquery';
import classNames from 'classnames';

import React, { useState, useEffect, useContext } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Link } from '@material-ui/core';
import { ListingContext } from 'contexts';
import { useLanguage } from 'hooks';
import { ENG } from 'config/constants';

interface Section {
  title: string;
  section: string;
}

const useStyles = makeStyles({
  navigator: {
    position: 'fixed',
    top: '40%',
    right: '20px',
    width: '15px',
    height: '115px',
    flexDirection: 'column',
    alignItems: 'center',
  },
  link: {
    position: 'relative',
    width: '12px !important',
    height: '12px !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#FFF',
    borderRadius: '50%',
    border: '1px solid #CCC',
    boxSizing: 'border-box',
    marginBottom: '16px',
    cursor: 'pointer',

    '&::before': {
      content: '""',
      padding: '4px',
      background: '#FFF',
      borderRadius: '50%',
    },

    '&::after': {
      content: '""',
      position: 'absolute',
      top: '11px',
      width: '2px',
      height: '12px',
      background: '#1E3067',
      margin: '2px auto',
    },

    '&:last-child::after': {
      display: 'none',
    },

    '& span': {
      position: 'absolute',
      right: '20px',
      color: '#000',
      fontSize: '10px',
      fontFamily: 'Ford Antenna',
      letterSpacing: '0.3px',
      lineHeight: '16px',
      whiteSpace: 'nowrap',
      borderRadius: '8px',
      borderColor: 'gray',
      borderWidth: '1px',
      borderStyle: 'solid',
      background: '#fff',
      padding: '4px 8px 4px 8px',
    },

    '&.Active': {
      '&::before': {
        background: '#00BDF2',
      },

      '& span': {
        display: 'block',
        animation: 'grow .4s ease-in',
        background: '#00BDF2',
        color: '#000',
        borderWidth: 0,
      },
    },
  },
});

let g_sections = [];

function Navigator() {
  const intl = useIntl();
  const styles = useStyles();
  const language = useLanguage();

  const { listing } = useContext(ListingContext);
  const [sections, setSections] = useState([]);
  const [activeSection, setActiveSection] = useState('');

  g_sections = sections;

  const pictures = listing?.pictures || [];
  const rooms = listing?.rooms || [];
  const videos = listing?.videos || [];
  const urls = _.compact([listing?.matterPortURL, listing?.virtualVisitURL]);

  const updateSections = _.debounce(() => {
    const isEnglish = language === ENG;
    const sectionElements = $('.section');

    const _sections = [];
    for (let i = 0; i < sectionElements.length; i++) {
      const sectionElement = sectionElements.eq(i);
      const section = sectionElement.data('section');

      let title = '';
      if (section.startsWith('video-')) {
        const index = Number(section.replace('video-', ''));
        const video = listing.videos[index];
        title = isEnglish ? video?.display_name : video?.display_name_fr;
      } else {
        title = intl.formatMessage({ id: `deliver.${section}.title` });
      }
      _sections.push({ title, section } as Section);
    }

    setSections(_sections);
  }, 1000);

  const isSectionVisible = (section: string) => {
    const element = $(`.section.${section}`)?.eq(0);
    if (!element) return false;

    const sTop = element.offset()?.top;
    const sBottom = sTop + element.outerHeight() - 1;

    const min = _.max([sTop, window.pageYOffset]);
    const max = _.min([sBottom, window.pageYOffset + window.innerHeight]);
    return min <= max;
  };

  const updateActiveSection = _.debounce(() => {
    let _section: string = null;
    for (let i = 0; i < g_sections.length; i++) {
      const { section } = g_sections[i];
      if (isSectionVisible(section)) {
        _section = section;
        break;
      }
    }

    if (_section) {
      setActiveSection(_section);
    }
  }, 100);

  const onSelectSection = (e: any, section: string) => {
    e.preventDefault();

    const element = $(`.section.${section}`)[0];
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  useEffect(updateSections, [pictures.length, rooms.length, videos.length, urls.length, language]);
  useEffect(updateActiveSection, [sections.length]);
  useEffect(() => {
    window.addEventListener('scroll', updateActiveSection);
    window.addEventListener('resize', updateActiveSection);
    return () => {
      window.removeEventListener('scroll', updateActiveSection);
      window.removeEventListener('resize', updateActiveSection);
    };
  }, []);

  return (
    <Box className={styles.navigator}>
      {sections.map((element: Section) => {
        return (
          <Link
            key={element.section}
            href='#'
            className={classNames(styles.link, {
              Active: element.section === activeSection,
            })}
            onClick={(e: any) => {
              return onSelectSection(e, element.section);
            }}
          >
            <span>{element.title}</span>
          </Link>
        );
      })}
    </Box>
  );
}

export default Navigator;
